import dynamic from 'next/dynamic';
const InnerHTML = dynamic(() => import('dangerously-set-html-content'), {ssr: false})

const AnalyticsScriptInjector = ({ data }) => {
    return (
        <InnerHTML html={data} />
    );
  };
  
  export default AnalyticsScriptInjector;
  